module.exports = __webpack_public_path__ + "static/media/fly0253.6df90f30.webp";